import { render, staticRenderFns } from "./ResultItemSightings.vue?vue&type=template&id=94ce5f28&scoped=true"
import script from "./ResultItemSightings.vue?vue&type=script&lang=js"
export * from "./ResultItemSightings.vue?vue&type=script&lang=js"
import style0 from "./ResultItemSightings.vue?vue&type=style&index=0&id=94ce5f28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ce5f28",
  null
  
)

export default component.exports